import { Component, input, output } from '@angular/core';
import { EmailProvider } from '@v2/modules/email-app/services/email-oauth.service';

@Component({
  selector: 'oiq-email-provider-select',
  imports: [],
  templateUrl: './email-provider-select.component.html',
})
export class EmailProviderSelectComponent {
  welcomeTitle = input('Welcome to the Email Application');
  description = input(
    'Select your email provider and start using the Email Application in just a few minutes'
  );

  providerSelected = output<EmailProvider>();

  onProviderClick(provider: EmailProvider) {
    this.providerSelected.emit(provider);
  }
}
